import { Box } from '@mui/material';
import useStyles from './HeaderComponentStyles';

export const HeaderComponent = ({ title }) => {
    const classes = useStyles();
    return (
        <Box>
            <label className={classes.headerPage}>{title}</label>
        </Box>
    );
};
